/**
 * @generated SignedSource<<869397b12f852e01db2b91db0bb8e2f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespL1Landing_viewer$data = {
  readonly l1ModuleLandingPageFF: boolean | null;
  readonly " $fragmentType": "SbRespL1Landing_viewer";
};
export type SbRespL1Landing_viewer$key = {
  readonly " $data"?: SbRespL1Landing_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespL1Landing_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespL1Landing_viewer",
  "selections": [
    {
      "alias": "l1ModuleLandingPageFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "l1ModuleLandingPage"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"l1ModuleLandingPage\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1c3f98d47f9809a5e01b3be4472fd4e8";

export default node;
